import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import './Facilities.scss';
import { PORT_FACILITIES } from 'constants/ports';

const FacilitiesForm = ({ initialValues, onSubmit, onCancel }) => {
    const [values, setValues] = React.useState(initialValues || {});

    const handleChange = (name, checked) => {
        setValues(prev => ({
            ...prev,
            [name]: checked,
        }));
    };

    return (
        <div className='facilities-block'>
            <div className='facilities-grid'>
                {PORT_FACILITIES.map(({ name, label }) => (
                    <div key={name}>
                        <Checkbox
                            checked={values[name] || false}
                            label={label}
                            onCheck={(e, checked) => handleChange(name, checked)}
                        />
                    </div>
                ))}
            </div>
            <div className='form-actions'>
                <RaisedButton
                    label='Save'
                    primary
                    onClick={() => onSubmit(values)}
                />
                <RaisedButton
                    label='Cancel'
                    secondary
                    onClick={onCancel}
                />
            </div>
        </div>
    );
};

FacilitiesForm.propTypes = {
    initialValues: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default FacilitiesForm;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/Facilities/FacilitiesForm.jsx